export const headerredraw = {
  data() {
    return {
      headerHeight: null,
    };
  },
  methods: {
    redraw(size) {
      this.$nextTick(() => {
        this.headerHeight = size.height;
      });
    },
  }
};